import React, { useState } from "react";
import { About_Laptop, RoundShape } from "../Assets";
import { Modal } from "react-bootstrap";

const About = () => {
  const [show, setShow] = useState(false);

  const handleModal = () => {
    setShow(true);
  };
  return (
    <div className="about-area pt-5 pb-5" id="aboutUs">
      <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
        <div className=" row d-flex align-items-center">
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="ml-about-img">
              <img src={About_Laptop} alt="About" />
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12 text-center">
            <div className="ml-about-content">
              <span className="sub-title">About Us</span>
              <h2>
                Innovating IT Solutions & Customer Support <br />
                Since 2001{" "}
              </h2>
              <div className="bar"></div>
              <p style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}>
                <span style={{ color: "#293a48", fontWeight: "500" }}>
                  About Sankara Software
                </span>{" "}
                - Headquartered in the U.S. with a global presence, Sankara
                Software delivers world-class technology solutions through
                delivery and support centers across the USA, Canada, and India.
                Since 1986, we’ve been committed to helping businesses grow and
                innovate through premium software development and customer
                support services.
              </p>
              <p style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}>
                In 2001, we sharpened our strategic focus toward next-generation
                digital solutions—specializing in enterprise applications, data
                warehousing, business intelligence, and cutting-edge web
                technologies. Our advanced development center in Chennai powers
                projects for clients across diverse geographies and industries.
              </p>
              <p style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}>
                <span style={{ color: "#293a48", fontWeight: "500" }}>
                  Cybersecurity Practice{" "}
                </span>
                Security isn’t just a feature—it’s embedded into our DNA. We
                offer full-spectrum cybersecurity services, including secure
                software architecture, compliance-driven development (PCI-DSS,
                HIPAA, ISO 27001), risk assessment frameworks, and proactive
                threat modeling. Our team helps safeguard clients’ digital
                assets through robust application security and resilient design.
              </p>

              {/* <a className="btn btn-secondary" >
                Discover More
              </a> */}
              <button
                className="btn btn-secondary"
                onClick={() => handleModal()}
              >
                Discover More
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="shape1">
        <img src={RoundShape} alt="shape##" />
      </div>
      <div className="shape2 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
      <div className="shape3">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
          alt="shape"
        />
      </div>
      <div className="shape4">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape7">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape8 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <div className="modal-content-custom" style={{ padding: "30px" }}>
          <Modal.Header closeButton className="modal-header-custom">
            {/* <Modal.Title>Admin - {selectedProduct.date}</Modal.Title> */}
          </Modal.Header>

          <Modal.Body className="modal-body-custom">
            <div>
              <h3
                className="mb-4"
                style={{ fontWeight: 600, color: "rgb(41 58 72 / 78%)" }}
              >
                <sapn>Our Team</sapn>
                <span
                  style={{ fontSize: "33px", color: "rgb(41 58 72 / 80%)" }}
                >
                  {" "}
                  &{" "}
                </span>
                <span>Capabilities</span>
              </h3>
              <ul
                style={{
                  textAlign: "left",
                  marginTop: "25px",
                }}
              >
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    Certified experts in technology, domain consulting, and
                    project delivery
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    PMP-certified project managers ensuring disciplined
                    execution
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    A process-driven development approach rooted in best
                    practices
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    Proven excellence in building custom software and
                    multi-platform solutions
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    Functional consultants with deep industry knowledge
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    Customer-centric account management and responsive service
                    delivery
                  </p>
                </li>
                <li>
                  <p
                    style={{ color: "rgb(41 58 72 / 79%)", fontWeight: "400" }}
                  >
                    Cyber-security expertise
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: "rgb(41 58 72 / 78%)",
                  fontWeight: "500",
                  marginTop: "25px",
                }}
              >
                We thrive on trusted partnerships, meticulous execution, and
                bold thinking. At Sankara, digital transformation starts with
                tailored technology and ends with lasting impact.
              </p>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default About;
